import React from 'react';
import { setImage } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';

export function CompanyStamp(props) {
  const { fromForm, dataIndex, editingInput, deleteItem, value, iconCompanyPath, dppAddEditAccess, isProductArchived } = props;

  const handleImageError = (event) => {
    event.target.src = noImage;
  };

  return (
    <div className="company-stamp-control">
      {/* default page start */}
      {!value && !iconCompanyPath && (
        <div className="company-stamp-navigation empty-navigation .icon ">
          <i className="icon icon-DAM-1" />
        </div>
      )}
      {/* default page end */}
      {iconCompanyPath && (
        <div className="heading-icon">
          <figure>
            <img src={iconCompanyPath ? setImage(iconCompanyPath) : noImage} alt="" onError={handleImageError} />
          </figure>
        </div>
      )}
      {fromForm && (
        <CommonAction
          editingInput={editingInput}
          deleteItem={deleteItem}
          dataIndex={dataIndex}
          dppAddEditAccess={dppAddEditAccess}
          isProductArchived={isProductArchived}
        />
      )}
    </div>
  );
}
export default CompanyStamp;
